import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { Driver } from "interfaces/driver";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onDriverFound", "onDriverNotFound", "onFailure"],
    success: [],
    failure: ["error", "validationErrors"],
    reset: [],
  },
  { prefix: "FIND_OR_CREATE_DRIVER_" }
);

export interface FindOrCreateDriverState {
  loading: boolean;
  error: string | null;
  validationErrors: Record<string, any>[];
}

export interface FindOrCreateDriverRequest {
  postData: Record<string, unknown>;
  onDriverFound?: (driver: Driver) => void;
  onDriverNotFound?: () => void;
  onFailure?: () => void;
}

interface Failure {
  error: string;
  validationErrors: Record<string, any>[];
}

const INITIAL_STATE: FindOrCreateDriverState = {
  loading: false,
  error: null,
  validationErrors: [],
};

const request = (state: FindOrCreateDriverState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: FindOrCreateDriverState) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: FindOrCreateDriverState, action: Failure) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
    validationErrors: { $set: action.validationErrors },
  });

const reset = () => INITIAL_STATE;

export const findOrCreateDriver = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FindOrCreateDriverTypes = Types;
export const FindOrCreateDriverActions = Creators;
